module.exports = __webpack_public_path__ + "img/arrow-right.fd6fac47.svg";